<template id="project-page">
  <div class="content-wrapper project-page-content">
    <div class="row gy-4">
      <div class="col-12 col-lg-8">
        <h2 class="title mb-0">{{ title }}</h2>
      </div>
      <div class="col-12 col-lg-4 text-right d-flex align-items-center">
        <div class="search-wrapper">
          <input
            v-model.lazy="keyword"
            class="mr-3"
            type="text"
            name="search-project"
            id="search-project"
            placeholder="Search experiences"
          />
          <i class="fas fa-search"></i>
        </div>
      </div>
    </div>
    <!-- <div class="sub-heading">Short Description about this title</div> -->

    <div class="card card-content-list">
      <div class="row gx-3 g-0 py-3" v-for="item in projects" :key="item.id">
        <div class="col-md-12 col-lg-6">
          <carousel
            :items-to-show="1"
            v-if="item.projectImages.length > 0"
            :autoplay="5000"
            :wrap-around="true"
          >
            <slide v-for="image in item.projectImages" :key="image.id">
              <img
                :src="`${baseUrl}/attachments/${image.imagePath}`"
                class="rounded img-content-list img-fluid"
                alt="logo"
              />
            </slide>

            <template #addons>
              <navigation />
              <pagination />
            </template>
          </carousel>
          <img
            v-else
            src="@/assets/images/placeholders/placeholder_2.jpg"
            class="rounded img-content-list img-fluid"
            alt="logo"
          />
        </div>
        <div class="col-md-12 col-lg-6">
          <div class="card-body">
            <h5
              :class="[
                'card-title',
                item.projectImages.length == 0 ? 'mt-5 mt-lg-0' : ''
              ]"
            >
              {{ item.title }}
            </h5>
            <p
              class="card-text text-justify"
              v-if="item.description.length > 300 && !item.isExpand"
            >
              {{ item.description.substring(0, 300) }}
              <br />
              <a class="cursor-pointer" @click="item.isExpand = true"
                >Read More</a
              >
            </p>
            <p class="card-text text-justify" v-else>
              {{ item.description }}
              <br />
              <a
                class="cursor-pointer"
                v-if="item.description.length > 300"
                @click="item.isExpand = false"
                >Read Less</a
              >
            </p>
            <!-- <p class="card-text"><small class="text-muted"></small></p> -->
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-2"></div>
      <div class="col-8 text-center paginations-area">
        <div
          v-if="totalPage > 0"
          class="
            intro-y
            col-span-12
            d-flex
            flex-wrap
            justify-content-center
            pagination-content-list
          "
        >
          <ul class="pagination m-auto">
            <li v-if="currentPage > 1">
              <a class="pagination__link cursor-pointer" @click="currentPage--">
                <i class="fas fa-chevron-left"></i>
              </a>
            </li>
            <li v-if="currentPage >= 3">
              <a
                class="pagination__link cursor-pointer"
                @click="currentPage = 1"
                >1</a
              >
            </li>
            <li v-if="currentPage >= 3 && currentPage - 2 != 1">
              <a class="pagination__link cursor-pointer">...</a>
            </li>

            <li v-if="currentPage > 1">
              <a
                class="pagination__link cursor-pointer"
                @click="currentPage--"
                >{{ currentPage - 1 }}</a
              >
            </li>
            <li>
              <div class="circleActive">
                <a
                  class="
                    pagination__link
                    cursor-pointer
                    pagination__link--active
                  "
                  >{{ currentPage }}</a
                >
              </div>
            </li>
            <li v-if="currentPage + 1 <= totalPage">
              <a
                class="pagination__link cursor-pointer"
                @click="currentPage = currentPage + 1"
                >{{ currentPage + 1 }}</a
              >
            </li>
            <li v-if="currentPage + 2 == totalPage">
              <a
                class="pagination__link cursor-pointer"
                @click="currentPage = currentPage + 2"
                >{{ currentPage + 2 }}</a
              >
            </li>
            <li v-if="totalPage - (currentPage + 1) > 1">
              <a class="pagination__link cursor-pointer">...</a>
            </li>
            <li v-if="totalPage - (currentPage + 1) > 1">
              <a
                class="pagination__link cursor-pointer"
                @click="currentPage = totalPage"
                >{{ totalPage }}</a
              >
            </li>
            <li v-if="currentPage + 1 <= totalPage">
              <a class="pagination__link cursor-pointer" @click="currentPage++">
                <i class="fas fa-chevron-right"></i>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="col-2"></div>
    </div>
  </div>
  <!-- <div class="d-none">{{ servicesType }}</div> -->
</template>

<script>
import { CHANGE_NAVIGATION_ITEMS } from '@/store/app.module'
import { NAVIGATION_EXPERIENCES } from '@/core/constant/navigation'
import { mapActions } from 'vuex'
import { GetAllPublic as GetAll } from '@/core/services/entities/projects.service'
import { BASE_URL } from '@/core/constant/env'
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'
import logisticServicesImg from '@/assets/images/altus/logistics-services.jpg'
import manpowerServicesImg from '@/assets/images/altus/manpower-services.jpg'
import marineServicesImg from '@/assets/images/altus/marine-services.jpg'
import supplyBaseServicesImg from '@/assets/images/altus/supplybase-services.jpg'
import supportServicesImg from '@/assets/images/altus/support-services.jpg'

export default {
  data() {
    return {
      baseUrl: BASE_URL,
      currentPage: 1,
      totalItems: 0,
      recordsPerPage: 5,
      curretType: null,
      projects: [],
      keyword: ''
    }
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation
  },
  watch: {
    currentPage() {
      switch (this.$route.name) {
        case 'logistic-experiences':
          this.DoGetProjects(1)
          break
        case 'supply-base-experiences':
          this.DoGetProjects(2)
          break
        case 'marine-experiences':
          this.DoGetProjects(3)
          break
        case 'manpower-experiences':
          this.DoGetProjects(4)
          break
        case 'support-experiences':
          this.DoGetProjects(5)
          break
        default:
          break
      }
    }
  },
  computed: {
    totalPage() {
      if (this.totalItems == 0) {
        return 0
      } else {
        return Math.ceil(this.totalItems / this.recordsPerPage)
      }
    },
    title() {
      switch (this.$route.name) {
        case 'logistic-experiences':
          return 'Logistics Experiences'
        case 'supply-base-experiences':
          return 'Supply Base Experiences'
        case 'marine-experiences':
          return 'Marine Experiences'
        case 'manpower-experiences':
          return 'Manpower Experiences'
        case 'support-experiences':
          return 'Support Experiences'
        default:
          return 0
      }
    }
    // servicesType() {
    //   switch (this.$route.name) {
    //     case 'logistic-experiences':
    //       this.DoGetProjects(1)
    //       this.ChangeImage(logisticServicesImg)
    //       return 1
    //     case 'supply-base-experiences':
    //       this.DoGetProjects(2)
    //       this.ChangeImage(supplyBaseServicesImg)
    //       return 2
    //     case 'marine-experiences':
    //       this.DoGetProjects(3)
    //       this.ChangeImage(marineServicesImg)
    //       return 3
    //     case 'manpower-experiences':
    //       this.DoGetProjects(4)
    //       this.ChangeImage(manpowerServicesImg)
    //       return 4
    //     case 'support-experiences':
    //       this.DoGetProjects(5)
    //       this.ChangeImage(supportServicesImg)
    //       return 5
    //     default:
    //       return 0
    //   }
    // }
  },
  methods: {
    ...mapActions('app', ['ChangeLoadingState']),
    ChangeImage(path) {
      this.currentPage = 1
      if (document.getElementById('header-image')) {
        document.getElementById(
          'header-image'
        ).style.backgroundImage = `url(${path})`
      }
    },
    async DoGetProjects(type) {
      this.ChangeLoadingState(true)
      try {
        const response = await GetAll(
          type,
          this.currentPage,
          this.recordsPerPage,
          this.keyword
        )
        if (response.status === 200) {
          if (response.data.isSuccess) {
            this.totalItems = response.data.totalRows
            let holder = response.data.data
            holder.forEach((element) => {
              element.isExpand = false
            })
            this.projects = holder
          }
        }
      } catch (error) {
        // TODO : Toast here
      } finally {
        this.ChangeLoadingState(false)
      }
    }
  },
  beforeMount() {
    this.$store.dispatch(`app/${CHANGE_NAVIGATION_ITEMS}`, null)
  },
  mounted() {
    switch (this.$route.name) {
      case 'logistic-experiences':
        this.DoGetProjects(1)
        document.getElementById(
          'header-image'
        ).style.backgroundImage = `url(${logisticServicesImg})`
        return 1
      case 'supply-base-experiences':
        this.DoGetProjects(2)
        document.getElementById(
          'header-image'
        ).style.backgroundImage = `url(${supplyBaseServicesImg})`
        return 2
      case 'marine-experiences':
        this.DoGetProjects(3)
        document.getElementById(
          'header-image'
        ).style.backgroundImage = `url(${marineServicesImg})`
        return 3
      case 'manpower-experiences':
        this.DoGetProjects(4)
        document.getElementById(
          'header-image'
        ).style.backgroundImage = `url(${manpowerServicesImg})`
        return 4
      case 'support-experiences':
        this.DoGetProjects(5)
        document.getElementById(
          'header-image'
        ).style.backgroundImage = `url(${supportServicesImg})`
        return 5
      default:
        return 0
    }
  }
}
</script>